/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Ship-Outline Icon component.
 */
export const AssetShipOutlinedIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d="M8.18896 17.8945C8.18896 17.6184 8.41282 17.3945 8.68896 17.3945H22.4537C22.7298 17.3945 22.9537 17.6184 22.9537 17.8945V21.53C22.9537 21.8061 22.7298 22.03 22.4537 22.03H8.68897C8.41282 22.03 8.18896 21.8061 8.18896 21.53V17.8945Z" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M10.4858 11.3867C10.4858 11.1106 10.7097 10.8867 10.9858 10.8867H13.0481C13.3242 10.8867 13.5481 11.1106 13.5481 11.3867V16.894C13.5481 17.1702 13.3242 17.394 13.0481 17.394H10.9858C10.7097 17.394 10.4858 17.1702 10.4858 16.894V11.3867Z" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M17.6475 14.1211C17.6475 13.845 17.8713 13.6211 18.1475 13.6211H20.2097C20.4859 13.6211 20.7097 13.845 20.7097 14.1211V16.8938C20.7097 17.1699 20.4859 17.3938 20.2097 17.3938H18.1475C17.8713 17.3938 17.6475 17.1699 17.6475 16.8938V14.1211Z" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M27.2131 18.8232C27.0761 18.8232 26.9451 18.8794 26.8508 18.9787L23.9754 22.0029C23.881 22.1021 23.7501 22.1583 23.6131 22.1583H5.34787C5.01673 22.1583 4.77706 22.4744 4.86642 22.7933L6.60894 29.011C6.66944 29.2269 6.86621 29.3761 7.09039 29.3761H30.7083C30.9121 29.3761 31.0955 29.2524 31.1719 29.0635L35.0334 19.5106C35.1662 19.182 34.9243 18.8232 34.5698 18.8232H27.2131Z" stroke={stroke as any} strokeWidth="1.5"/>
    </svg>
  );
};

export default AssetShipOutlinedIcon;
